.satelliteDetails {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;

  max-width: max-content;

  text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;
}
